import { setup as popoverSetup } from 'popover';
import './popover.scss';
import SpriteSvg from './svg';
popoverSetup({
  createCloseIcon: function createCloseIcon() {
    var icon = new SpriteSvg();
    icon.iconName = 'icon_cross';
    return icon;
  }
});